import React, { useContext, useEffect, useReducer } from "react";

import { useUserCountDeals, useUserCountSourcings } from "models/users/apiUser";
import { useAllMyPermissions } from "models/users/apiUser";
import { AuthenticationContext } from "./AuthenticationProvider";

const INITIAL_STATE = {
  isLogged: undefined,
  email: "",
  id: null,
  username: "",
  first_name: "",
  last_name: "",
  fullname: "",
  is_active: false,
  refresh_deal_sourcing: false,
  backoffice: {
    isLogged: undefined,
  },
};

export const UserContext = React.createContext(null);

const reducer = (state, action) => {
  switch (action.type) {
    case "login": {
      return {
        ...state,
        email: action.data.email,
        isLogged: action.data.isLogged,
        id: action.data.id,
        username: action.data.username,
        first_name: action.data.first_name,
        last_name: action.data.last_name,
        fullname: action.data.fullname,
        is_active: action.data.is_active,
      };
    }
    case "logout": {
      return {
        ...state,
        ...INITIAL_STATE,
        isLogged: false,
      };
    }
    case "login_backoffice": {
      return {
        ...state,
        backoffice: {
          isLogged: true,
        },
      };
    }
    case "logout_backoffice": {
      return {
        ...state,
        backoffice: {
          isLogged: false,
        },
      };
    }
    default:
      throw new Error(`unkown action : ${action.type}`);
  }
};

const UserProvider = ({ children }) => {
  const [user, dispatch] = useReducer(reducer, INITIAL_STATE);
  const { appAxios } = useContext(AuthenticationContext);
  const { data: countSourcing, refetch: refetchCountSourcing } =
    useUserCountSourcings("me");
  const { data: countDeal, refetch: refetchCountDeal } =
    useUserCountDeals("me");
  const { data: permissions, refetch: refetchPermissions } =
    useAllMyPermissions("me");

  useEffect(() => {
    appAxios.get("/api/users/me/").then((response) => {
      dispatch({ data: response.data, type: "login" });
    });
  }, []);

  useEffect(() => {
    if (!user.isLogged) return;
    refetchCountDeal();
    refetchCountSourcing();
    refetchPermissions();
  }, [user]);

  const hasPermission = (permission) => {
    if (!permissions) return false;
    return permissions.indexOf(permission) > -1;
  };

  return (
    <UserContext.Provider
      value={{
        user,
        dispatch,
        countDeal,
        countSourcing,
        refetchCountSourcing,
        permissions,
        hasPermission,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
